if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (this.form.querySelector('input[name=id]').value === "" || this.form.querySelector('input[name=id]').value === null) {
        Swal.fire({
          title: '',
          text: "You have to choose at least one option!",
          icon: 'warning',
          confirmButtonColor: '#d16832',
          cancelButtonColor: '#ccc',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              let el_h4_variant = document.querySelectorAll("fieldset.product-form__input h4");
              if (el_h4_variant.length > 0) {
                var topPos = el_h4_variant[0].offsetTop;
                window.scroll({
                  top: topPos,
                  left: 0,
                  behavior: "smooth"
                });

                // for (var i = 0; i < el_h4_variant.length; i++) {
                //   el_h4_variant[i].setAttribute("style", "color:red;");
                // }
              }
            }, 500);

          }
        });
      }
      else {
        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.dataset.cartType != 'page') {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // var variant_id = this.form.querySelector('input[name=id]').value;
        // var product_id = this.form.querySelector('input[name=product_id]').value;
        // var selling_plan_id = this.form.querySelector('input[name=selling_plan]') == null ? undefined : this.form.querySelector('input[name=selling_plan]').value;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.dataset.cartType == 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            var variant_id = response.variant_id ?? "";
            var product_id = response.product_id ?? "";
            var selling_plan_id = response.selling_plan_allocation == undefined ? undefined : response.selling_plan_allocation.selling_plan.id;

            this.getDataFromApi().then(data => {
              (data.items).map((item, index) => {

                if (item.product_id == product_id && item.variant_id == variant_id && (item?.selling_plan_allocation?.selling_plan.id != selling_plan_id)) {
                  this.deleteDataDuplicate(item.key, response);
                  this.form.querySelector('input[name=check_add_to_cart]').value = "true";
                }

                if (this.form.querySelector('input[name=check_add_to_cart]').value == "false" && (data.items.length - 1) == index) {
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener('modalClosed', () => {
                      setTimeout(() => { this.cart.renderContents(response) });
                    }, { once: true });
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                  this.cart.open();

                }
                else if ((data.items.length - 1) == index) {
                  this.form.querySelector('input[name=check_add_to_cart]').value = "false";
                }
              })
            })

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
    }

    getDataFromApi() {
      return fetch(`${routes.cart_url}.js`).then(response => response.json())
    }

    deleteDataDuplicate(id, responseProduct) {
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "post",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: id,
          quantity: 0
        })
      }).then(res => res.json())
        .then((data) => {
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(responseProduct) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(responseProduct);
          }

          document.querySelector("#cart-notification-button").innerHTML = `View my cart (${data.item_count})`;
          document.querySelector(".cart-count-bubble span").innerHTML = `${data.item_count}`;

          this.cart.open();
        })
        .catch(err => console.log(err));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

  });
}

